module.exports = __webpack_public_path__ + "static/media/visibilitat-02.db7d1732.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visibilitat/visibilitat-02.svg
// module id = 782
// module chunks = 0